import request from "@/router/axios";

/**
 * 条件分页查询异常取餐记录
 * @param data
 */
export function fetchList(data) {
  return request({
    url: `/foodmac_macruntime/macWorkOrder/macWorkOrderPage`,
    method: "post",
    data: data,
  });
}

/**
 * 根据工单ID查询警报
 * @param {Number} macId
 * @param {Number} workOrderId
 */
export function findAllByMacIdAndWordOrderId(params) {
  return request({
    url: `/foodmac_macruntime/macRuntime/findAllByMacIdAndWordOrderId?macId=${params.macId}&workOrderId=${params.workOrderId}`,
    method: "get"
  });
}

/**
 * 根据机器ID以及工单ID查询订单ID
 * @param {Number} macId
 * @param {Number} workOrderId
 */
export function selectOrderId(params) {
  return request({
    url: `/pickv2/workOrder/selectOrderId?macId=${params.macId}&workOrderId=${params.workOrderId}`,
    method: "get"
  });
}

/**
 * 查询工单详情
 * @returns
 */
export function selectMacWorOrder(workOrderId, macId) {
  return request({
    url: `/foodmac_macruntime/macWorkOrder/selectMacWorOrder?workOrderId=${workOrderId}&macId=${macId}`,
    method: "get",
  });
}

/**
 * 获取最新完成工单id
 * 1 原料 2 商品 3 辅料 4 菜品
 * @returns
 */
export function selectMacWorOrderForBoss(macId) {
  return request({
    url: `/foodmac_macruntime/macWorkOrder/selectMacWorOrderForBoss?macId=${macId}`,
    method: "get",
  });
}

/**
 * 获取IOT消息
 * @param {*}  
 * @returns 
 */
//  export function getMacMsg(param) {
//   return request({
//     url: `/foodmac_macruntime/macRuntime/getMacMsg?page=${param.page}&size=${param.size}&macId=${param.macId}&beginTime=${param.beginTime}&endTime=${param.endTime}&workOrderId=${param.workOrderId}`,
//     method: "get",
//   });
// }
export function getMacMsg(param) {
  return request({
    url: `/foodmac_macruntime/macRuntime/getMacMsg`,
    method: "post",
    data: param,
  });
}

/**
 * 根据订单编号模糊查询
 */
export function selectByOrderNoFuzzy(orderNo) {
  return request({
    url: `/foodmac_order/order/selectByOrderNoFuzzy?orderNo=${orderNo}`,
    method: "get",
  });
}

/**
 * 工单列表
 * @param {*} data 
 * @param {*} page 
 * @param {*} size 
 * @returns 
 */
  export function searchPageWorkList(data,page,size) {
    return request({
      url: `/foodmac_macruntime/workOrder/search?page=${page}&size=${size}`,
      method: "post",
      data
    });
  }

/**
 * 陈总展示用-不显示三代机-工单列表
 * @param {*} data 
 * @param {*} page 
 * @param {*} size 
 * @returns 
 */
  export function foodmacMacruntimeWorkorderV2Search(data,page,size) {
    return request({
      url: `/foodmac_macruntime/workOrder/v2/search?page=${page}&size=${size}`,
      method: "post",
      data
    });
  }

  /**
   * 查询温度趋势
   * @param {*} data 
   * @returns 
   */
  export function foodmacMacruntimeWorkorderFindworkorderstatisticlist(data) {
    return request({
      url: `/foodmac_macruntime/workOrder/findWorkOrderStatisticList`,
      method: "post",
      data
    });
  }